import React from "react";
import style from './OurServicesCard.module.css';

export default function OurServicesCard({data}){

    return(

        <div    
            data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="1" data-aos-offset="100" 
            style={{backgroundColor: data.bgColor}} className={style.OurServicesCard_container}>
            <div style={{backgroundColor: data?.bgColorForIcon}}><img src={data.icon} alt="icon" /></div>
            <p>{data.heading}</p>
            <p>{data.content}</p>
        </div>
    )
}